import OnlineStatus from '../models/OnlineStatus';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useIsCapabilityEnabled from './useIsCapabilityEnabled';
import { Capability } from '../../core/models/user-capability';
import UpdateStatus from '../models/UpdateStatus';
import useUpdateInstallCapabilities from './useUpdateInstallCapabilities';
import { InstallationStatus } from '../../core/components/grid/cell-renderers/InstallationStatusCellRenderer';

export default function useDisabledUpdateTooltipText(): (params: {
  device?: { onlineStatus: OnlineStatus };
  updateInProgress?: boolean;
  updateStatus?: UpdateStatus;
  installationStatus?: InstallationStatus;
}) => string | null {
  const userIsPatchManagementCapable = useIsCapabilityEnabled(Capability.PatchManagement);
  const updateInstallCapabilities = useUpdateInstallCapabilities();
  const { t } = useTranslation();

  return useCallback(
    ({ device = undefined, updateInProgress = false, installationStatus = undefined, updateStatus = undefined }) => {
      if (!userIsPatchManagementCapable) {
        return t('tooltips.disabledUpdateNotPremium');
      }
      if (!device) {
        return null;
      }

      if (!!updateStatus && !updateInstallCapabilities.hasUpdatesToInstall({ updateStatus })) {
        return t('tooltips.noUpdatesToInstall');
      }

      if (installationStatus === 'RestartRequired') {
        return t('tooltips.disabledRestartRequired');
      }

      if (updateInProgress) return t('tooltips.disabledUpdateInProgress');

      return null;
    },
    [t, updateInstallCapabilities, userIsPatchManagementCapable]
  );
}
